import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./locales/nl.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import pl from "./locales/pl.json";
import tr from "./locales/tr.json";

const STORAGE_KEY = "beecenter_lang";
export const SUPPORTED_LANGS = ["nl", "en", "de", "fr", "es", "it", "pt", "pl", "tr"];

const saved = (() => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v && SUPPORTED_LANGS.includes(v) ? v : null;
  } catch {
    return null;
  }
})();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      pl: { translation: pl },
      tr: { translation: tr },
    },
    lng: saved || undefined,
    fallbackLng: "nl",
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: STORAGE_KEY,
    },
  });

i18n.on("languageChanged", (lng) => {
  try {
    const code = (lng || "").slice(0, 2).toLowerCase();
    const norm = SUPPORTED_LANGS.includes(code) ? code : "nl";
    localStorage.setItem(STORAGE_KEY, norm);
  } catch {}
});

export default i18n;
